import React, { useState } from 'react';
import { ImageMap } from '@qiuz/react-image-map';

const FloorImage = ({ mapArea, image }) => {
  //   const [mapArea, setMapArea] = useState(
  //     rooms.map((room) => {
  //       return {
  //         ...room,
  //         left: room.leftPin,
  //         top: room.topPin,
  //         style: {
  //           background: `rgba(${room.color}, 0.1)`,
  //           border: `2px solid rgb(${room.color})`,
  //         },
  //         selected: true,
  //       };
  //     }),
  //   );

  // const [mapArea, setMapArea] = useState([
  //   {
  //     left: '69%',
  //     top: '0%',
  //     height: '35%',
  //     width: '30%',
  //     style: {
  //       background: 'rgb(0,128,0,0.1)',
  //       border: '2px solid rgb(0,128,0)',
  //       cursor: 'pointer',
  //     },
  //   },
  // ]);
  return (
    <div>
      <ImageMap
        className='usage-map'
        src={image}
        map={mapArea}
        width='100%'
        height='100%'
      />
    </div>
  );
};

export default FloorImage;
